module.exports = __webpack_public_path__ + "static/anticimex-logo-b24c5553d8e937a0468fb40ff0bcbc31.png";